/**
 * clipping-module.js
 *
 * Add docs
 *
 */

(function (window, ss, imports, exports) {
  var ClippingFilmStrip = imports("ClippingFilmStrip"),
    ClippingIndicators = imports("ClippingIndicators"),
    clippingUtil = imports("clippingUtil"),
    clippingFilmStrip,
    clippingIndicators,
    constants = {
      MAX_TOP_CLIPS: 5,
    },
    selectors = {
      slideStage: ".stage",
      slideImage: ".slide_image",
      progressBar: ".j-progress-bar",
    };

  /**
   * Creates a new ClippingModule instance with optional configuration.
   * @constructor
   */
  function ClippingModule(config) {
    this.config = config;
    this._init();
  }

  ClippingModule.prototype = /** @lends ClippingModule.prototype */ {
    constructor: ClippingModule,

    /**
     * Initialize modules
     * @returns {void}
     */
    _init: function () {
      var clipCounts = this.config.clipCounts,
        totalSlides = this.config.totalSlides,
        topClips = clippingUtil.getTopClips(
          clipCounts,
          constants.MAX_TOP_CLIPS
        ),
        slides = clippingUtil.getSlides(selectors.slideImage),
        decoratedSlides = $.extend(true, slides, topClips);

      clippingFilmStrip = new ClippingFilmStrip({
        targetEl: selectors.slideStage,
        progressBarEl: selectors.progressBar,
        slides: decoratedSlides,
        slideCount: totalSlides,
      });

      clippingIndicators = new ClippingIndicators({
        topClips: topClips,
        slideCount: totalSlides,
      });
    },
  };

  // Export as module
  exports("ClippingModule", ClippingModule);
})(
  window,
  window.slideshare_object,
  window.slideshare_object.utils.imports,
  window.slideshare_object.utils.exports
);
